
export default [{
	path: '/receipts',
	component: () => import('@/components/receipts/List')
}]
